import React, { useState } from 'react'

const GoogleMap = () => {
    const [activeLocation, setActiveLocation] = useState('rotterdam');

    const locations = {
        delhi: {
            label: 'New Delhi',
            url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.6383511194663!2d77.1188033752622!3d28.550588075709584!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1dd4186868c1%3A0xc2d4946cf9eb5ac6!2sCOWRKS%20Aerocity%2C%20Worldmark%201%20Tower%20A!5e0!3m2!1sen!2sin!4v1711962654294!5m2!1sen!2sin'
        },
        rotterdam: {
            label: 'Rotterdam',
            url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2461.0354500788434!2d4.468600776660691!3d51.92393737190048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c434a2493d19e3%3A0x659fc24b04f49569!2sWeena%20690%2C%203012%20CN%20Rotterdam%2C%20Netherlands!5e0!3m2!1sen!2sin!4v1713000000000!5m2!1sen!2sin'
        }
    };

    return (
        <div className="google-map-area section text-center section-padding-bottom">
            <div className="container">
                <div className="map-location-tabs mb-4" data-aos="fade-up">
                    <button
                        className={`map-tab-btn ${activeLocation === 'rotterdam' ? 'active' : ''}`}
                        onClick={() => setActiveLocation('rotterdam')}
                    >
                        Rotterdam
                    </button>
                    <button
                        className={`map-tab-btn ${activeLocation === 'delhi' ? 'active' : ''}`}
                        onClick={() => setActiveLocation('delhi')}
                    >
                        New Delhi
                    </button>
                </div>
                <div className="contact-map-area" data-aos="fade-up">
                    <iframe
                        title={`${locations[activeLocation].label} Location`}
                        src={locations[activeLocation].url}
                        aria-hidden="false"
                    ></iframe>
                </div>
            </div>
        </div>
    )
}

export default GoogleMap;
